import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-title" }
const _hoisted_2 = {
  key: 1,
  class: "text-center mt-8"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "mt-12 action-buttons" }

import type { AllowedModel } from '@/services/merchantConfigService';
import { useConfigStore } from '@/stores/configStore';
import { computed, onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsDialog',
  setup(__props) {

const configStore = useConfigStore();

const selectedModel = ref<AllowedModel>('gpt-4o-mini');
const apiKey = ref('');

const modelOptions = [
  { title: 'GPT-4o Mini', value: 'gpt-4o-mini' },
  { title: 'GPT-4o', value: 'gpt-4o' },
  { title: 'GPT-4.1 Mini', value: 'gpt-4.1-mini' },
  { title: 'GPT-4.1 Nano', value: 'gpt-4.1-nano' },
  { title: 'GPT-4.1', value: 'gpt-4.1' },
];

const canSave = computed(() => {
  return selectedModel.value && apiKey.value.trim() && !configStore.isSaving;
});

const handleSave = async () => {
  try {
    if (configStore.config) {
      await configStore.updateConfig({
        model: selectedModel.value,
        llm_api_key: apiKey.value,
      });
    } else {
      await configStore.createConfig({
        model: selectedModel.value,
        llm_api_key: apiKey.value,
      });
    }
  } catch (error) {
    console.error('Failed to save configuration:', error);
  }
};

const handleDelete = async () => {
  if (
    confirm(
      'Are you sure you want to delete this configuration? This action cannot be undone.',
    )
  ) {
    try {
      await configStore.deleteConfig();
      // Reset form
      selectedModel.value = 'gpt-4o-mini';
      apiKey.value = '';
    } catch (error) {
      console.error('Failed to delete configuration:', error);
    }
  }
};

onMounted(async () => {
  await configStore.loadConfig();
  if (configStore.config) {
    selectedModel.value = configStore.config.model;
    // API key is not returned from the server for security reasons
    apiKey.value = '';
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, { "max-width": "723" }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _createVNode(_component_v_btn, _mergeProps(activatorProps, {
        icon: "",
        size: "40",
        class: "settings-icon",
        "aria-label": "Open settings"
      }), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            size: 24,
            "aria-hidden": "true"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("mdi-cog-outline", -1)
            ])),
            _: 1,
            __: [5]
          })
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(({ isActive }) => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Settings", -1)),
            _createVNode(_component_v_btn, {
              icon: "",
              size: "40",
              variant: "text",
              "aria-label": "Close settings dialog",
              onClick: ($event: any) => (isActive.value = false)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: 24,
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("mdi-close-circle-outline", -1)
                  ])),
                  _: 1,
                  __: [6]
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "settings-subtitle mt-3" }, " Configure the model and API key used for your integration ", -1)),
          (_unref(configStore).error)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "error",
                closable: "",
                class: "mt-6",
                "onClick:close": _cache[0] || (_cache[0] = ($event: any) => (_unref(configStore).clearError()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(configStore).error), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(configStore).isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_progress_circular, { indeterminate: "" })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_select, {
                  modelValue: selectedModel.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedModel).value = $event)),
                  flat: "",
                  "hide-details": "",
                  "bg-color": "#f9f9f9",
                  "icon-color": "1E1E1E",
                  label: "LLM Model",
                  variant: "solo-filled",
                  items: modelOptions,
                  class: "mt-8",
                  disabled: _unref(configStore).isSaving
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_v_text_field, {
                  modelValue: apiKey.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((apiKey).value = $event)),
                  flat: "",
                  "hide-details": "",
                  "bg-color": "#f9f9f9",
                  label: "API Key",
                  type: "password",
                  variant: "solo-filled",
                  class: "mt-4",
                  disabled: _unref(configStore).isSaving
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("div", _hoisted_4, [
                  (_unref(configStore).config)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        variant: "outlined",
                        class: "delete-btn",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleDelete())),
                        loading: _unref(configStore).isSaving
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode(" Delete Configuration ", -1)
                        ])),
                        _: 1,
                        __: [8]
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    variant: "tonal",
                    class: "save-btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleSave())),
                    loading: _unref(configStore).isSaving,
                    disabled: !canSave.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(configStore).config
                  ? 'Update Configuration'
                  : 'Save Configuration'), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ])
              ]))
        ]),
        _: 2,
        __: [9]
      }, 1024)
    ]),
    _: 1
  }))
}
}

})